"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRouter = exports.Router = exports.RouterContext = void 0;
const react_1 = __importStar(require("react"));
const link_interceptor_1 = require("./link-interceptor");
const history_1 = require("./history");
const match_in_1 = require("./match-in");
const throwNoContext = () => {
    throw new Error("You must put a <Router> at the root of the application.");
};
exports.RouterContext = react_1.createContext({
    url: new URL(window.location.href),
    previousUrl: null,
    transitionId: 0,
    push: throwNoContext,
    replace: throwNoContext,
    back: throwNoContext,
    match: throwNoContext,
    matchIn: throwNoContext,
});
const Router = ({ children }) => {
    const [history] = react_1.useState(() => {
        const history = new history_1.History();
        history.onChange((action) => {
            setState((state) => ({
                url: new URL(window.location.href),
                previousUrl: state.url,
                transitionId: action === "replace" ? state.transitionId : state.transitionId + 1,
            }));
        });
        return history;
    });
    const [state, setState] = react_1.useState(() => ({
        url: new URL(window.location.href),
        previousUrl: null,
        transitionId: 0,
    }));
    react_1.useEffect(() => {
        return () => {
            history.dispose();
        };
    }, [history]);
    return (react_1.default.createElement(exports.RouterContext.Provider, { value: {
            url: state.url,
            previousUrl: state.previousUrl,
            transitionId: state.transitionId,
            push: history.push,
            replace: history.replace,
            back: history.back,
            match: (route) => route.match(state.url),
            matchIn: (routes) => match_in_1.matchIn(routes, state.url),
        } },
        react_1.default.createElement(link_interceptor_1.LinkInterceptor, null, children)));
};
exports.Router = Router;
const useRouter = () => react_1.useContext(exports.RouterContext);
exports.useRouter = useRouter;
